import { useEffect, useCallback } from 'react';
import { useInspectionStore } from '../store';
import { OnDone, SubmitForm } from '../slices/inspection';

export interface UseInspectionSubmitResult {
  submitForm: SubmitForm;
  isSaving: boolean;
  skipRedirectAfterSave: boolean;
  setSkipRedirectAfterSave: (skip: boolean) => void;
}

export function useInspectionSubmit(
  onDone?: OnDone
): UseInspectionSubmitResult {
  const saveDraftInspection = useInspectionStore.use.saveDraftInspection();
  const finishInspection = useInspectionStore.use.finishInspection();
  const isSaving = useInspectionStore.use.isSaving();
  const skipRedirectAfterSave = useInspectionStore.use.skipRedirectAfterSave();
  const setOnDone = useInspectionStore.use.setOnDone();
  const setSkipRedirectAfterSave =
    useInspectionStore.use.setSkipRedirectAfterSave();

  useEffect(() => {
    if (onDone) {
      setOnDone(onDone);
    }
  }, [onDone, setOnDone]);

  const safeSubmitForm: SubmitForm = useCallback(
    async (form, uploaders, options) => {
      if (onDone) {
        setOnDone(onDone);
      }
      if (options?.finish) {
        return finishInspection(form, uploaders, options);
      }

      return saveDraftInspection(form, uploaders, options);
    },
    [finishInspection, onDone, saveDraftInspection, setOnDone]
  );

  return {
    submitForm: safeSubmitForm,
    isSaving,
    skipRedirectAfterSave,
    setSkipRedirectAfterSave,
  };
}
